import { newToolFilterOAuthMcp } from "../oauth.ts";

export const amplitudeMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://amplitude.com/nextjs-public/favicon/apple-touch-icon.png",
  // US region; EU-resident projects use https://mcp.eu.amplitude.com/mcp.
  url: "https://mcp.amplitude.com/mcp",
  label: "Amplitude",
});
